import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCompositionApi from '@vue/composition-api'
import VueScrollTo from 'vue-scrollto'
import VCalendar from 'v-calendar'
import VueDragscroll from 'vue-dragscroll'


// 汎用パーツ
import BackgroundImage from './components/partial/BackgroundImage.vue'
import DocumentLink from './components/partial/DocumentLink.vue'
import PCButtonHistoryBack from './components/pc/partial/PCButtonHistoryBack.vue'
import SPButtonHistoryBack from './components/sp/partial/SPButtonHistoryBack.vue'
import ButtonViewLater from './components/pc/partial/ButtonViewLater.vue'
import ButtonEdit from './components/pc/partial/ButtonEdit.vue'
import ButtonClose from './components/pc/partial/ButtonClose.vue'
import ButtonChangePosition from './components/pc/partial/ButtonChangePosition.vue'
import ButtonCopyOther from './components/pc/partial/ButtonCopyOther.vue'

// グローバル処理
import globalMixin from './util/global'
import handleScrollMixin from './util/handlescroll'
import menuMixin from './util/menu'
import printMixin from './util/print'

import IconMenuSvg from '@/components/svg/IcnMenu.vue'
import IconLaterSvg from '@/components/svg/IcnLater.vue'
import IconNoteSvg from '@/components/svg/IcnNote.vue'
import IconHistorySvg from '@/components/svg/IcnHistory.vue'
import IconPaperSvg from '@/components/svg/IcnPaper.vue'
import IconListSvg from '@/components/svg/IcnList.vue'
import IconList2Svg from '@/components/svg/IcnList2.vue'
import IconThemeSvg from '@/components/svg/IcnTheme.vue'
import IconSearchSvg from '@/components/svg/IcnSearch.vue'

// fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'



library.add(fas, far, fal)

Vue.use(VueCompositionApi)
Vue.use(VueScrollTo)
Vue.use(VCalendar)
Vue.use(VueDragscroll)
Vue.mixin(globalMixin)
Vue.mixin(handleScrollMixin)
Vue.mixin(menuMixin)
Vue.mixin(printMixin)
Vue.component('FontawesomeIcon', FontAwesomeIcon)
Vue.component('IconMenu', IconMenuSvg)
Vue.component('IconLater', IconLaterSvg)
Vue.component('IcnNote', IconNoteSvg)
Vue.component('IcnHistory', IconHistorySvg)
Vue.component('IcnPaper', IconPaperSvg)
Vue.component('IcnList', IconListSvg)
Vue.component('IcnList2', IconList2Svg)
Vue.component('IcnTheme', IconThemeSvg)
Vue.component('IcnSearch', IconSearchSvg)
Vue.component('BackgroundImage', BackgroundImage)
Vue.component('DocumentLink', DocumentLink)
Vue.component('PCButtonHistoryBack', PCButtonHistoryBack)
Vue.component('SPButtonHistoryBack', SPButtonHistoryBack)
Vue.component('ButtonViewLater', ButtonViewLater)
Vue.component('ButtonEdit', ButtonEdit)
Vue.component('ButtonClose', ButtonClose)
Vue.component('ButtonChangePosition', ButtonChangePosition)
Vue.component('ButtonCopyOther', ButtonCopyOther)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
